/** BrandMark — the portal glyph (3-stroke mark, no letters), shared by TopBar and LoginPage. */
export default function BrandMark({ color = '#fff', size = 18 }: { color?: string; size?: number }) {
  return (
    <svg aria-hidden="true" focusable="false" width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path d="M6 7h11M6 12h8M6 17h11" stroke={color} strokeWidth="2.25" strokeLinecap="round" />
    </svg>
  );
}
